import { useEffect, useState, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { DetailDateFormatter } from '../../../shared/controls/formatters';
import ComposeEmail from './compose';
import { useDispatch } from 'react-redux';

const Email = ({ localData, module }) => {
  const [activeTab, setActiveTab] = useState('tab1');
  const [showPopup4, setShowPopup4] = useState(false);
  const [showPopup5, setShowPopup5] = useState(false);
  const [sentData, setSentData] = useState([]);
  const [scheduledData, setScheduledData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [viewEmail, setViewEmail] = useState(false);
  const [viewData, setViewData] = useState({});

  useEffect(() => {
    if (localData?.emails) {
      const { sent, stop, scheduled } = localData?.emails?.reduce(
        (acc, item) => {
          if (item.status !== 'Scheduled') acc.sent.push(item);
          else if (item.status === 'Scheduled') acc.scheduled.push(item);
          return acc;
        },
        { sent: [], stop: [], scheduled: [] }
      );

      setSentData(sent);
      setScheduledData(scheduled);
    }
  }, [localData]);

  const campaignData = [
    {
      campaignName: 'Product Newsletter carlssa-kidman@mail.com',
      status: 'Received',
      source: 'Mass Email',
      date: 'Sep 27, 2022',
      sentBy: 'Nov 20, 2024',
      action: 'view,edit,delete',
    },
    {
      campaignName: 'Product Newsletter jenny-smith@mail.com',
      status: 'Sent',
      source: 'Mass Email',
      date: 'Oct 10, 2022',
      sentBy: 'Nov 25, 2024',
      action: 'view,edit,delete',
    },
    {
      campaignName: 'Product Launch Email mark-lee@mail.com',
      status: 'Received',
      source: 'Newsletter',
      date: 'Oct 15, 2022',
      sentBy: 'Nov 18, 2024',
      action: 'view,edit',
    },
  ];

  const campaignColumnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerName: '',
      width: 20,
      suppressSizeToFit: true,
    },
    { headerName: 'Campaign Name', field: 'campaignName', width: 150 },
    { headerName: 'Status', field: 'status', width: 150 },
    { headerName: 'Source', field: 'campaignType', width: 150 },
    { headerName: 'Start Date', field: 'startDate', width: 150 },
    { headerName: 'End Date', field: 'endDate', width: 150 },
    { headerName: 'Owner', field: 'owner', width: 150 },
    {
      headerName: 'Action',
      field: 'action',
      width: 150,
      cellRendererFramework: (params) => {
        const actions = params.data.action.split(',');

        return (
          <div className="action-buttons">
            {actions.includes('view') && (
              <button className="action-btn" onClick={() => viewCampaign(params)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-eye"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 3C4.686 3 2.21 4.844 1.254 6.5 2.21 8.156 4.686 10 8 10s5.79-1.844 6.746-3.5C13.79 4.844 11.314 3 8 3zM8 9c-2.607 0-4.788-1.597-5.88-3.68 1.092-2.083 3.273-3.68 5.88-3.68s4.788 1.597 5.88 3.68C12.788 7.403 10.607 9 8 9z" />
                </svg>
              </button>
            )}

            {actions.includes('edit') && (
              <button className="action-btn" onClick={() => editCampaign(params)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil"
                  viewBox="0 0 16 16"
                >
                  <path d="M12.146 1.854a2 2 0 0 1 2.828 2.828l-9.708 9.708-2.336.584a1 1 0 0 1-1.215-1.215l.584-2.336 9.708-9.708a2 2 0 0 1 2.828 2.828zM11.5 4.207l-8.5 8.5L2 13.207 10.5 4.707a2 2 0 0 1 2.828 2.828z" />
                </svg>
              </button>
            )}

            {actions.includes('delete') && (
              <button className="action-btn" onClick={() => deleteCampaign(params)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V5.5zM14 3a1 1 0 0 0-1-1h-3V1a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v1h12V3z" />
                </svg>
              </button>
            )}
          </div>
        );
      },
      cellStyle: { textAlign: 'left' },
    },
  ];
  const viewCampaign = (params) => {
    alert(`Viewing campaign: ${params.data.campaignName}`);
  };

  const editCampaign = (params) => {
    alert(`Editing campaign: ${params.data.campaignName}`);
  };

  const deleteCampaign = (params) => {
    alert(`Deleting campaign: ${params.data.campaignName}`);
  };

  const handleView = (data) => {
    const updatedData = { ...data, type: 'preview' };
    setViewData(updatedData);
    setViewEmail(true);
  };

  useEffect(() => {
    // Add event listener for Bootstrap tab changes
    const handleTabShown = (event) => {
      setActiveTab(event.target.getAttribute('href').replace('#', ''));
    };

    document
      .querySelectorAll('[data-bs-toggle="tab"]')
      .forEach((tab) => tab.addEventListener('shown.bs.tab', handleTabShown));

    return () => {
      // Cleanup event listeners
      document
        .querySelectorAll('[data-bs-toggle="tab"]')
        .forEach((tab) => tab.removeEventListener('shown.bs.tab', handleTabShown));
    };
  }, []);

  const openPopup4 = () => {
    setShowPopup4(true);
  };

  const openPopup5 = () => {
    setShowPopup5(true);
  };

  const handleClose = () => {
    setShowPopup5(false);
    setShowPopup4(false);
  };
  const handleChange = () => {
    setSelectedOptions();
  };
  const handleViewClose = () => {
    setViewEmail(false);
  };

  return (
    <>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12">
          <div className="infoBox">
            <div className="addlead-header" id="composemail">
              <label htmlFor="" className="flex-div align-items-center">
                <img className="me-2" src="../assets/images/emailIcon.svg" alt="" />
                Emails
              </label>
              <div className="emialTabRow">
                <ul className="nav nav-tabs justify-content-start">
                  <li className="nav-item">
                    <a
                      className={`nav-link ${activeTab === 'tab1' ? 'active' : ''}`}
                      href="#tab1"
                      data-bs-toggle="tab"
                    >
                      Emails Sent
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${activeTab === 'tab3' ? 'active' : ''}`}
                      href="#tab3"
                      data-bs-toggle="tab"
                    >
                      Scheduled
                    </a>
                  </li>
                </ul>
              </div>

              <div></div>
            </div>

            <div className="leadcontent">
              <>
                <div className="row">
                  <div className="col-12 col-md-12">
                    <div className="tab-content">
                      <div
                        className={`tab-pane fade ${activeTab === 'tab1' ? 'show active' : ''}`}
                        id="tab1"
                      >
                        <TabContent data={sentData} handleView={handleView} />
                      </div>
                      <div
                        className={`tab-pane fade ${activeTab === 'tab3' ? 'show active' : ''}`}
                        id="tab3"
                      >
                        <TabContent data={scheduledData} handleView={handleView} />
                      </div>
                    </div>
                    <div id="sendmail">
                      {viewEmail && (
                        <ComposeEmail localData={viewData} handleClose={handleViewClose} />
                      )}
                    </div>
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function TabContent({ data, handleView, handleStop, showCheckbox = false, selectedEmailFlag }) {
  const localGridRef = useRef();
  const emailSentColumnDefs = [
    {
      headerName: 'Actions',
      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return (
          <div className="action-menu">
            <img
              src="/assets/images/eye.png"
              alt="View"
              width="11px"
              onClick={() => handleView(paramsValue)}
            />
          </div>
        );
      },
      maxWidth: 100,
      sortable: false,
      filter: false,
      pinned: 'left',
    },
    { headerName: 'Subject', field: 'subject', width: 240 },
    {
      headerName: 'Date',
      field: 'createdDateTime',
      width: 150,
      valueFormatter: (params) => DetailDateFormatter(params.value),
    },
    { headerName: 'To Address', field: 'toAddress', width: 150 },
    { headerName: 'From Address', field: 'fromAddress', width: 150 },
    {
      headerName: 'Status',
      field: 'status',
      width: 150,
      valueFormatter: (params) => {
        const status = params.value;
        return status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : 'Unknown';
      },
    },
  ];
  return (
    <div className="cutome_ag_theme" id="viewPageGrid">
      <div className="ag-theme-balham tbl_height">
        <AgGridReact
          rowData={data}
          columnDefs={emailSentColumnDefs}
          defaultColDef={{
            flex: 1,
            minWidth: 100,
            resizable: true,
          }}
          rowSelection="multiple"
          alwaysShowVerticalScroll={true}
          ref={localGridRef}
        />
      </div>
    </div>
  );
}

export default Email;
